import { Button } from "@9amhealth/shared";
import styled from "@emotion/styled";
import React, { useEffect } from "react";
import UserCubit, {
  ProfileAttributesKeys
} from "src/state/UserCubit/UserCubit";
import StatusBarBloc from "src/hybrid/components/StatusBarBloc";
import { DisableAppPadding } from "src/ui/components/AppRouter/AppRouter";
import Translate from "src/ui/components/Translate/Translate";
import { APP_BREAKPOINT, APP_CONTENT_WIDTH } from "src/constants/layout";
import HomePageExpectationManagement from "src/ui/assets/images/home-page-bg-hwj.webp";
import StepList from "src/ui/components/StepList/StepList";
import { getHeadingProps, useFocusHeading } from "src/lib/useFocusHeading";
import { userPreferences, useBloc } from "src/state/state";
import steps from "src/constants/expectationManagementSteps";
import { UserPreferenceKeys } from "src/state/UserPreferencesCubit/UserPreferencesCubit";
import { addContextToExpectationManagementStep } from "src/lib/addContextToExpectationManagementStep";

const ManagementScreenWrap = styled.div`
  label: ManagementScreenWrap;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  background: var(--onboarding-background, transparent);
  z-index: 10;

  @media screen and (min-width: ${APP_BREAKPOINT}px) {
    position: relative;
    min-height: 100vh;
    padding-top: 4.5rem;
  }
`;

const BackgroundImage = styled.img`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
  opacity: var(--onboarding-background-opacity, 1);
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0 1.5rem;
  margin-top: 6rem;

  @media screen and (min-width: ${APP_BREAKPOINT}px) {
    border: 0.5px solid rgba(230, 227, 219, 1);
    padding-top: 5rem;
    margin-top: 0;
  }
`;

const StepsWrapper = styled.div`
  label: OnboardingStepsWrapper;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
  gap: 2rem;
  justify-content: space-between;
  max-width: ${APP_CONTENT_WIDTH}px;

  @media screen and (min-width: ${APP_BREAKPOINT}px) {
    backdrop-filter: blur(24px);
  }
`;

const Title = styled.h1`
  font-size: 2.25rem;
  margin-bottom: 2rem;
  text-align: center;

  @media screen and (min-width: ${APP_BREAKPOINT}px) {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  }
`;

const StepListWrapper = styled.div``;
const TopSection = styled.div``;

const BottomSection = styled.div`
  position: relative;
  z-index: 2;
  align-self: stretch;
  display: flex;
  justify-content: center;
  margin-top: auto;
  padding: 1.5rem 1.5rem 3.625rem 1.5rem;
  backdrop-filter: blur(3px);
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.7) 100%
  );

  @media screen and (min-width: ${APP_BREAKPOINT}px) {
    backdrop-filter: blur(3px);
    padding: 1rem 0 2rem 0;
    background: unset;
  }

  > button {
    max-width: ${APP_CONTENT_WIDTH}px;
    width: 100%;
  }
`;

const ExpectationsManagementScreen = () => {
  const { headingRef } = useFocusHeading();
  const [{ profileAttributes }] = useBloc(UserCubit);
  const [, { resetThemeDefault }] = useBloc(StatusBarBloc);

  const userExperienceGroup =
    profileAttributes?.[ProfileAttributesKeys.experienceGroup];

  useEffect(() => {
    StatusBarBloc.temporaryThemeColor = "transparent";
    resetThemeDefault();

    return () => {
      StatusBarBloc.temporaryThemeColor = null;
      resetThemeDefault();
    };
  }, [resetThemeDefault]);

  if (!userExperienceGroup) {
    return null;
  }

  const stepsToShow = addContextToExpectationManagementStep(
    steps,
    userExperienceGroup
  );

  const handleCtaPress = () => {
    void userPreferences.updateUserPreferences({
      [UserPreferenceKeys.showManagementExpectation]: false
    });
  };

  return (
    <ManagementScreenWrap>
      <DisableAppPadding />
      <BackgroundImage src={HomePageExpectationManagement} />
      <ContentWrapper>
        <StepsWrapper>
          <TopSection>
            <Title {...getHeadingProps()} ref={headingRef}>
              <Translate msg="onboardingExpectation.title" />
            </Title>

            <StepListWrapper>
              <StepList steps={stepsToShow} />
            </StepListWrapper>
          </TopSection>
        </StepsWrapper>
      </ContentWrapper>

      <BottomSection>
        <Button theme="charcoal" fullWidth onPress={handleCtaPress}>
          <Translate msg="getStarted" />
        </Button>
      </BottomSection>
    </ManagementScreenWrap>
  );
};

export default ExpectationsManagementScreen;
